import { PlusIcon } from '@/assets/plus-icon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { Skeleton } from './ui/skeleton';
import { useSession } from '@/services/providers/use-session.ts';
import { useTranslation } from 'react-i18next';
import { hasPermission } from '@/features/users/schemas/users.permissions.ts';
import { NotificationPopover } from '@/features/notifications/components/notification-popover.tsx';
import { CreateInviteUser } from '@/features/users/components/create-invite-user/create-invite-user.tsx';

export const QuickActionsNav = () => {
  const { isLoading, userId, role } = useSession();
  const { t } = useTranslation();

  const { isLoading: isNotificationsLoading } = useGetNotificationsQuery();

  if (isLoading || isNotificationsLoading) {
    return (
      <div className="flex gap-2">
        <Skeleton className="size-[40px] rounded-full" />
        <Skeleton className="size-[40px] rounded-full" />
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full p-0">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-full w-full rounded-full p-3 hover:bg-white">
              <PlusIcon />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            {hasPermission({ userId, role }, 'plants', 'create') && (
              <Link to="/create-plant">
                <DropdownMenuItem>{t('notifications.actions.create_plant')}</DropdownMenuItem>
              </Link>
            )}
            {hasPermission({ userId, role }, 'users', 'invite') && (
              <CreateInviteUser>
                <DropdownMenuItem onSelect={(event) => event.preventDefault()} disabled={true}>
                  {t('notifications.actions.invite_user')}
                </DropdownMenuItem>
              </CreateInviteUser>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <NotificationPopover />
    </div>
  );
};
